// Brisa — Sync aria-expanded del trigger con el estado real del <x-modal> drawer.
// Necesario porque el Custom Element del theme Concept no propaga `hidden` al trigger
// automáticamente. Sin esto, el chevron CSS (rotate(180deg) on [aria-expanded="true"])
// no se dispara nunca al abrir/cerrar el drawer.

(function () {
  'use strict';

  function sync(trigger, drawer) {
    const isOpen = !drawer.hasAttribute('hidden');
    trigger.setAttribute('aria-expanded', String(isOpen));
  }

  function wire(trigger) {
    const id = trigger.getAttribute('aria-controls');
    if (!id) return;
    const drawer = document.getElementById(id);
    if (!drawer) return;
    const observer = new MutationObserver(() => sync(trigger, drawer));
    observer.observe(drawer, { attributes: true, attributeFilter: ['hidden'] });
    sync(trigger, drawer);
  }

  function init() {
    document.querySelectorAll('.brisa-family-trigger[aria-controls]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
